import { EventEmitter, Injectable, Output } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LoaderService {
  @Output() loader: EventEmitter<boolean> = new EventEmitter<boolean>();

  showLoader(): void {
    this.loader.emit(true);
  }

  hideLoader(): void {
    this.loader.emit(false);
  }
}
